import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const TimerLiner24 = ()=>{
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M15.24 2.5H8.76004C5.00004 2.5 4.71004 5.88 6.74004 7.72L17.26 17.28C19.29 19.12 19 22.5 15.24 22.5H8.76004C5.00004 22.5 4.71004 19.12 6.74004 17.28L17.26 7.72C19.29 5.88 19 2.5 15.24 2.5Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
